import React, { useEffect, useState, useRef } from 'react'
import { useRouter } from 'next/router'
// import FromTo from "../hero/hero-rslhome/FromTo";
import HotelDestinationCity from '../../components/hero/hero-rslhome/flight/ActivityDestinationCityActivity'
import ActivityDestinationCityPace from '../../components/hero/hero-rslhome/flight/ActivityDestinationCityPace'
import Selector from '../hero/hero-rslhome/Selector'
import PersonSelect from '../hero/hero-rslhome/PersonSelect'
import SeatClass from '../hero/hero-rslhome/SeatClass'
import DatePicker from 'react-multi-date-picker'
// import DatePickerFromTo from "../hero/hero-rslhome/DatePickerFromToFlight";
import DatePickerFromTo from '../hero/hero-rslhome/DatePickerFromToFlightSingleDate'
import GuestSearch from '../rental-list/common/GuestSearchFlight'
import CircularProgress from '@mui/material/CircularProgress'

import { useSelector } from 'react-redux'
import { dispatch } from '../../redux/store'
import { airportNameList, airportNameList1, clearListData } from '../../redux/slices/flight'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import moment from 'moment'
import Head from 'next/head'

import { debounce } from 'lodash'

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';


const customTheme = createTheme({
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#ffffff', // Change to your desired color
          width: '20px !important',
          height: '20px !important'
        }
      }
    }
  }
})

const FlightsRSL = () => {
  const router = useRouter()
  const autocompleteFirst = useRef()
  const autocompleteNext = useRef()
  const [isButtonDisabled, setIsButtonDisabled] = useState(false)
  const { flightListNameRes, flightListName1Res, error, isLoading } =
    useSelector(state => state.flight)
  const [searchFromValue, setSearchFromValue] = useState('')
  const [searchToValue, setSearchToValue] = useState('')
  const [searchDepartValue, setSearchDepartValue] = useState('')
  const [searchReturnValue, setSearchReturnValue] = useState('')
  const [loader, setLoader] = useState(false)
  const [loaderSearch, setLoaderSearch] = useState(false)
  const [cityValue, setCityValue] = useState([])
  const [cityValue1, setCityValue1] = useState([])
  const [searchProduct, setSearchProduct] = useState('')
  const [expanded, setExpanded] = useState(false)
  const [selectedValue, setSelectedValue] = useState({
    municipality: '',
    iata_code: ''
  })
  const [searchProduct1, setSearchProduct1] = useState('')
  const [selectedValue1, setSelectedValue1] = useState({
    municipality: '',
    iata_code: ''
  })

  const [guestCounts, setGuestCounts] = useState({
    Adults: 1,
    Children: 0,
    Infants: 0
  })
  const [filter, setFilter] = useState({
    from: '',
    to: '',
    depart: null,
    arrived: null,
    way: 1,
    passenger: {
      Adults: 1,
      Children: 0,
      Infants: 0
    },
    seatType: 1
  })

  const [loading, setLoading] = useState(true)

  const [focusFirst, setFocusFirst] = useState(true)
  const [focusNext, setFocusNext] = useState(false)

  const [isSubmitClicked, setIsSubmitClicked] = useState(false)
  const [isFormValid, setIsFormValid] = useState(true)
  const [validationError, setValidationError] = useState('')
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm')); // md and above


  useEffect(() => {
    if (autocompleteFirst.current) {
      autocompleteFirst.current.querySelector('input').focus({ preventScroll: true })
    }
  }, [])

  useEffect(() => {
    if (filter) {
      if (filter.way === 1) {
        if (filter.from !== '' && filter.to !== '' && filter.depart !== null) {
          setIsButtonDisabled(false)
        } else {
          setIsButtonDisabled(true)
        }
      } else {
        if (
          filter.from !== '' &&
          filter.to !== '' &&
          filter.depart !== null &&
          filter.arrived !== null
        ) {
          setIsButtonDisabled(false)
        } else {
          setIsButtonDisabled(true)
        }
      }
    }
  }, [filter])

  useEffect(() => {
    if (guestCounts) {
      setFilter({ ...filter, ['passenger']: guestCounts })
    }
  }, [guestCounts])

  useEffect(() => {
    setIsSubmitClicked(false)
    setLoading(true)
    const debouncedSearch = debounce(query => {
      if (query.length > 2) {
        dispatch(
          airportNameList({
            from:
              searchProduct && searchProduct.length !== 0 ? searchProduct : ''
          })
        )
      }
    }, 500)

    if (searchProduct && searchProduct !== '') {
      debouncedSearch(searchProduct)
    }

    // Cleanup debounce function on unmount
    return () => debouncedSearch.cancel()
  }, [searchProduct])

  useEffect(() => {
    setIsSubmitClicked(false)
    setLoading(true)
    const debouncedSearch = debounce(query => {
      if (query.length > 2) {
        dispatch(
          airportNameList1({
            from:
              searchProduct1 && searchProduct1.length !== 0
                ? searchProduct1
                : ''
          })
        )
      }
    }, 500)

    if (searchProduct1 && searchProduct1 !== '') {
      debouncedSearch(searchProduct1)
    }

    // Cleanup debounce function on unmount
    return () => debouncedSearch.cancel()
  }, [searchProduct1])

  useEffect(() => {
    if (selectedValue && selectedValue.iata_code) {
      if (selectedValue?.iata_code !== selectedValue1?.iata_code) {
        setValidationError("");
      }
      setFilter({ ...filter, ['from']: selectedValue.iata_code })
      if (selectedValue1 && selectedValue1.iata_code) {
        setExpanded(true);
      }
    }
  }, [selectedValue])

  useEffect(() => {
    if (selectedValue1 && selectedValue1.iata_code) {
      if (selectedValue?.iata_code !== selectedValue1?.iata_code) {
        setValidationError("");
      }
      setFilter({ ...filter, ['to']: selectedValue1.iata_code })
      if (selectedValue && selectedValue.iata_code) {
        setExpanded(true);
      }
    }
  }, [selectedValue1])

  useEffect(() => {
    if (flightListNameRes) {
      const myObjectDestination = {}
      const childArrayDestination = []
      const mainArray = []
      if (flightListNameRes) {
        if (flightListNameRes.length > 0) {
          flightListNameRes.map(data => {
            myObjectDestination.label = 'Departure'
            myObjectDestination.img = '/img/general/flag.png'

            childArrayDestination.push(data)
            myObjectDestination.values = childArrayDestination
          })
        } else {
          myObjectDestination.label = 'Departure'
          myObjectDestination.values = []
        }
      }
      mainArray.push(myObjectDestination)
      setCityValue(mainArray)
    }
  }, [flightListNameRes])

  useEffect(() => {
    if (flightListName1Res) {
      const myObjectDestination = {}
      const childArrayDestination = []
      const mainArray = []
      if (flightListName1Res) {
        if (flightListName1Res.length > 0) {
          flightListName1Res.map(data => {
            myObjectDestination.label = 'Destination'
            myObjectDestination.img = '/img/general/flag.png'

            childArrayDestination.push(data)
            myObjectDestination.values = childArrayDestination
          })
        } else {
          myObjectDestination.label = 'Destination'
          myObjectDestination.values = []
        }
      }
      mainArray.push(myObjectDestination)

      setCityValue1(mainArray)
    }
  }, [flightListName1Res])

  const handleBooking = () => {
    setLoader(true)
    router.push({
      pathname: '/flights/flights',
      query: {
        from: filter.from,
        to: filter.to,
        fromData: JSON.stringify(selectedValue),
        toData: JSON.stringify(selectedValue1),
        depart: filter.depart,
        arrived: filter.arrived,
        way: filter.way,
        adults: filter.passenger.Adults,
        children: filter.passenger.Children,
        infants: filter.passenger.Infants,
        seatType: filter.seatType
      }
    })
  }

  const checkWayOfType = (way) => {
    if (way === 2) {
      return (selectedValue?.municipality !== '' &&
        selectedValue1?.iata_code !== '' &&
        filter?.depart !== null &&
        filter?.arrived !== null)
    }

    return (selectedValue?.municipality !== '' &&
      selectedValue1?.iata_code !== '' &&
      filter?.depart !== null)

  }

  const handleBookingSearch = () => {
    setIsSubmitClicked(true)
    dispatch(clearListData());
    setValidationError("");

    // ✅ New validation
    if (selectedValue?.iata_code === selectedValue1?.iata_code) {
      setIsFormValid(false)
      setValidationError('Departure and Arrival airports cannot be the same.')
      return
    }

    if (
      checkWayOfType(filter.way)
    ) {
      setLoaderSearch(true)
      setLoader(true)
      router.push({
        pathname: '/flights/flights',
        query: {
          from: filter.from,
          to: filter.to,
          depart: filter.depart,
          fromData: JSON.stringify(selectedValue),
          toData: JSON.stringify(selectedValue1),
          arrived: filter.arrived,
          way: filter.way,
          adults: filter.passenger.Adults,
          children: filter.passenger.Children,
          infants: filter.passenger.Infants,
          seatType: filter.seatType
        }
      })
    } else {
      setIsFormValid(false)
      setValidationError('Please fill in all fields.')
    }
  }

  useEffect(() => {
    if (error) {
      setLoading(false)
    }
  }, [error])

  return (
    <>
      <Head>
        <meta name='Flights RSL' />
        {/* <title>Flights</title> */}
      </Head>
      <div className='flights_rsl y-gap-20'>

        {isDesktop ? (
          <Accordion style={{
            padding: '2px 0px'
          }} expanded={expanded} onChange={(event, isExpanded) => { }} sx={{ boxShadow: "none" }}>
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent event bubbling
                    setExpanded(!expanded); // Control expansion manually
                  }}
                  sx={{ cursor: 'pointer' }}
                />
              }
              onClick={(e) => e.stopPropagation()} // Prevent summary click from toggling
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{
                padding: "0px",
                display: 'flex', alignItems: 'center', gap: 2, cursor: "auto !important", '&.Mui-focusVisible': {
                  backgroundColor: 'transparent', // Remove focus background
                },
              }}
            >
              {/* <div style={{ marginLeft: '12px', flex: 1 }}> */}
              <div style={{ flex: 1 }}>
                <div className='flight-booking'>
                  <ActivityDestinationCityPace
                    setCityValue={setCityValue}
                    cityValue={cityValue}
                    searchProduct={searchProduct}
                    setSearchProduct={setSearchProduct}
                    setSelectedValue={setSelectedValue}
                    selectedValue={selectedValue}
                    label='Departure airport'
                    placeholder='Departure airport'
                    setLoading={setLoading}
                    loading={loading}
                    autocompleteFirst={autocompleteFirst}
                    error={
                      isSubmitClicked && selectedValue?.municipality === ''
                        ? true
                        : false
                    }
                    helperText={
                      isSubmitClicked && selectedValue?.municipality === ''
                        ? 'Required'
                        : ''
                    }
                  />
                  <HotelDestinationCity
                    setCityValue={setCityValue1}
                    cityValue={cityValue1}
                    searchProduct={searchProduct1}
                    setSearchProduct={setSearchProduct1}
                    setSelectedValue={setSelectedValue1}
                    selectedValue={selectedValue1}
                    autocompleteNext={autocompleteNext}
                    focusNext={focusNext}
                    label='Arrival Airport'
                    placeholder='Arrival Airport'
                    setLoading={setLoading}
                    loading={loading}
                    error={
                      isSubmitClicked && selectedValue1?.municipality === ''
                        ? true
                        : false
                    }
                    helperText={
                      isSubmitClicked && selectedValue1?.municipality === ''
                        ? 'Required'
                        : ''
                    }
                  />
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: "8px 0px" }}>
              {/* <div className='flights_rsl y-gap-20' style={{ paddingLeft: "16px", paddingRight: "16px" }}> */}
              <div className='flights_rsl y-gap-20'>
                <div className='flight-booking'>
                  <DatePickerFromTo
                    height='150%'
                    placeholder='Depart'
                    className='dropdown-from'
                    setFilter={setFilter}
                    filter={filter}
                    error={isSubmitClicked && filter?.depart === null ? true : false}
                    helperText={
                      isSubmitClicked && filter?.depart === null ? 'Required' : ''
                    }
                  />
                  {filter.way === 2 && (
                    <DatePickerFromTo
                      height='150%'
                      className='dropdown-from'
                      placeholder='Return'
                      setFilter={setFilter}
                      filter={filter}
                      error={isSubmitClicked && filter?.arrived === null ? true : false}
                      helperText={
                        isSubmitClicked && filter?.arrived === null ? 'Required' : ''
                      }
                    />
                  )}
                </div>
                <div className='choose-trip choose-trip-flight'>
                  <div className='choose-trip__details'>
                    <Selector setFilter={setFilter} filter={filter} />
                    <div className='d-flex align-center justify-content-center justify-content-md-between'>
                      <GuestSearch
                        className='guest-search'
                        setGuestCounts={setGuestCounts}
                        guestCounts={guestCounts}
                      />
                      <SeatClass setFilter={setFilter} filter={filter} />
                    </div>
                  </div>
                  <div className='trip-booking__btn'>
                    <ThemeProvider theme={customTheme}>
                      <button
                        className='mainSearch__submit btn-1 button -dark-4 py-10 px-15  bg-dark-3 text-white w-75'
                        onClick={handleBookingSearch}
                      >
                        {loader ? <CircularProgress /> : 'Search'}
                      </button>
                    </ThemeProvider>
                  </div>
                </div>
              </div>
              {!isFormValid && validationError && (
                <div className="text-danger" style={{ marginTop: '10px' }}>
                  {validationError}
                </div>
              )}
            </AccordionDetails>
          </Accordion>)
          :
          (<>
            <div className='flight-booking'>
              <ActivityDestinationCityPace
                setCityValue={setCityValue}
                cityValue={cityValue}
                searchProduct={searchProduct}
                setSearchProduct={setSearchProduct}
                setSelectedValue={setSelectedValue}
                selectedValue={selectedValue}
                label='Departure airport'
                placeholder='Departure airport'
                setLoading={setLoading}
                loading={loading}
                autocompleteFirst={autocompleteFirst}
                error={
                  isSubmitClicked && selectedValue?.municipality === ''
                    ? true
                    : false
                }
                helperText={
                  isSubmitClicked && selectedValue?.municipality === ''
                    ? 'Required'
                    : ''
                }
              />
              <HotelDestinationCity
                setCityValue={setCityValue1}
                cityValue={cityValue1}
                searchProduct={searchProduct1}
                setSearchProduct={setSearchProduct1}
                setSelectedValue={setSelectedValue1}
                selectedValue={selectedValue1}
                autocompleteNext={autocompleteNext}
                focusNext={focusNext}
                label='Arrival Airport'
                placeholder='Arrival Airport'
                setLoading={setLoading}
                loading={loading}
                error={
                  isSubmitClicked && selectedValue1?.municipality === ''
                    ? true
                    : false
                }
                helperText={
                  isSubmitClicked && selectedValue1?.municipality === ''
                    ? 'Required'
                    : ''
                }
              />

              <DatePickerFromTo
                height='150%'
                placeholder='Depart'
                className='dropdown-from'
                setFilter={setFilter}
                filter={filter}
                error={isSubmitClicked && filter?.depart === null ? true : false}
                helperText={
                  isSubmitClicked && filter?.depart === null ? 'Required' : ''
                }
              />
              {filter.way === 2 ? (
                <DatePickerFromTo
                  height='150%'
                  className='dropdown-from'
                  placeholder='Return'
                  setFilter={setFilter}
                  filter={filter}
                  error={isSubmitClicked && filter?.arrived === null ? true : false}
                  helperText={
                    isSubmitClicked && filter?.arrived === null ? 'Required' : ''
                  }
                />
              ) : (
                ''
              )}
            </div>
            <div className='choose-trip'>
              <div className='choose-trip__details'>
                <Selector setFilter={setFilter} filter={filter} />

                <div className='d-flex align-center justify-content-center justify-content-md-between'>
                  <GuestSearch
                    className='guest-search'
                    setGuestCounts={setGuestCounts}
                    guestCounts={guestCounts}
                  />
                  <SeatClass setFilter={setFilter} filter={filter} />
                </div>
                {!isFormValid && validationError && (
                  <div className="text-danger" style={{ marginTop: '10px' }}>
                    {validationError}
                  </div>
                )}
                <div className='trip-booking__btn'>
                  <ThemeProvider theme={customTheme}>
                    <button
                      className='mainSearch__submit btn-1 button -dark-4 py-10 px-15  bg-dark-3 text-white w-75'
                      onClick={handleBookingSearch}
                    >
                      {loader ? <CircularProgress /> : 'Search'}
                    </button>
                  </ThemeProvider>
                </div>
              </div>
            </div>
          </>)
        }
      </div>
    </>
  )
}

export default FlightsRSL
